import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate, Link, useLocation } from 'react-router-dom';
import { API_URL } from '../config';
import { toast } from 'react-toastify';

function TransactionHistory() {
    const [transactions, setTransactions] = useState([]);
    const [loading, setLoading] = useState(true);
    const [page, setPage] = useState(0);
    const [totalPages, setTotalPages] = useState(0);
    const [totalElements, setTotalElements] = useState(0);
    const navigate = useNavigate();
    const location = useLocation();

    const token = localStorage.getItem('token');
    const role = localStorage.getItem('role');
    const userEmail = localStorage.getItem('email');

    useEffect(() => {
        if (!token || role !== 'WORKER') {
            navigate('/');
            return;
        }
        fetchTransactions();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [page]);

    const fetchTransactions = async () => {
        setLoading(true);
        try {
            const res = await axios.get(
                `${API_URL}/api/worker/transactions?page=${page}&size=20`,
                { headers: { Authorization: `Bearer ${token}` } }
            );
            const data = res.data.content || res.data;
            setTransactions(data);
            setTotalPages(res.data.totalPages || 1);
            setTotalElements(res.data.totalElements || data.length);
        } catch (err) {
            toast.error('Failed to load transactions');
        }
        setLoading(false);
    };

    const handleLogout = () => {
        localStorage.clear();
        navigate('/');
    };

    return (
        <div className="dashboard-layout">
            {/* SIDEBAR */}
            <aside className="sidebar">
                <Link to="/" className="sidebar-brand">infloir</Link>
                <nav className="sidebar-nav">
                    <Link to="/worker-dashboard" className="nav-item">
                        <span>📊</span> Dashboard
                    </Link>
                    <Link to="/wallet" className="nav-item">
                        <span>💰</span> Wallet
                    </Link>
                    <Link to="/worker/transactions" className={`nav-item ${location.pathname === '/worker/transactions' ? 'active' : ''}`}>
                        <span>🧾</span> Transactions
                    </Link>
                    <Link to="/worker/payouts" className="nav-item">
                        <span>💸</span> Payouts
                    </Link>
                    <Link to="/profile" className="nav-item">
                        <span>👤</span> Profile
                    </Link>
                </nav>
                <div style={{ marginTop: 'auto' }}>
                    <button onClick={handleLogout} className="nav-item" style={{ width: '100%', background: 'transparent', border: 'none', textAlign: 'left', cursor: 'pointer' }}>
                        <span>🚪</span> Log out
                    </button>
                </div>
            </aside>

            {/* MAIN CONTENT */}
            <div className="main-content">
                <header className="topbar">
                    <h2 style={{ fontSize: '18px', fontWeight: '500' }}>Transaction History</h2>
                    <span style={{ fontSize: '13px', color: 'var(--text-secondary)' }}>{userEmail}</span>
                </header>

                <main className="page-container page-fade-in">
                    {loading ? (
                        <div style={{ display: 'flex', justifyContent: 'center', padding: '60px' }}>
                            <div className="spinner" style={{ width: '24px', height: '24px', borderTopColor: '#fff' }}></div>
                        </div>
                    ) : transactions.length === 0 ? (
                        <div className="card" style={{ textAlign: 'center', padding: '60px 20px', color: 'var(--text-muted)' }}>
                            <p style={{ fontSize: '32px', marginBottom: '12px' }}>📊</p>
                            <p>No transactions yet.</p>
                        </div>
                    ) : (
                        <>
                            <div style={{ marginBottom: '16px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                <p style={{ fontSize: '13px', color: 'var(--text-secondary)' }}>
                                    Showing <strong style={{ color: 'var(--text)' }}>{totalElements}</strong> total transactions
                                </p>
                            </div>

                            <div className="table-container">
                                <table className="data-table">
                                    <thead>
                                        <tr>
                                            <th>Date</th>
                                            <th>Description</th>
                                            <th>Type</th>
                                            <th style={{ textAlign: 'right' }}>Amount</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {transactions.map(tx => (
                                            <tr key={tx.id}>
                                                <td style={{ color: 'var(--text-secondary)', fontSize: '13px' }}>
                                                    {new Date(tx.createdAt).toLocaleString()}
                                                </td>
                                                <td>{tx.description || '-'}</td>
                                                <td>
                                                    <span className="badge">{tx.type}</span>
                                                </td>
                                                <td style={{
                                                    textAlign: 'right',
                                                    fontWeight: '600',
                                                    color: tx.amount >= 0 ? 'var(--success)' : 'var(--text)'
                                                }}>
                                                    {tx.amount >= 0 ? '+' : ''}${parseFloat(tx.amount).toFixed(2)}
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>

                            {/* Pagination */}
                            {totalPages > 1 && (
                                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '16px', marginTop: '24px' }}>
                                    <button
                                        onClick={() => setPage(p => Math.max(0, p - 1))}
                                        disabled={page === 0}
                                        className="btn-secondary"
                                        style={{ padding: '8px 16px', fontSize: '13px' }}
                                    >
                                        ← Previous
                                    </button>
                                    <span style={{ fontSize: '13px', color: 'var(--text-secondary)' }}>
                                        Page {page + 1} of {totalPages}
                                    </span>
                                    <button
                                        onClick={() => setPage(p => Math.min(totalPages - 1, p + 1))}
                                        disabled={page >= totalPages - 1}
                                        className="btn-secondary"
                                        style={{ padding: '8px 16px', fontSize: '13px' }}
                                    >
                                        Next →
                                    </button>
                                </div>
                            )}
                        </>
                    )}
                </main>
            </div>
        </div>
    );
}

export default TransactionHistory;